import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "react";

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const Skeleton = ({ className = "", ...props }: SkeletonProps) => {
  const baseClasses = "animate-pulse rounded-md bg-global-secondary";

  const skeletonClasses = twMerge(baseClasses, className);

  return <div className={skeletonClasses} {...props} />;
};
